import { Skeleton } from "@/components/ui/skeleton";

import { useClaim } from "../api/use-claim";
import { ClaimTimeline } from "../components/timeline/claim-timeline";

export interface TimelineTabProps {
  claimId: string;
  variant?: "full" | "compact";
}

/** Port of pages/plugin/Timeline.vue. */
export function TimelineTab({ claimId }: TimelineTabProps) {
  const { data: claim } = useClaim(claimId);

  if (!claim) {
    return (
      <div className="space-y-4 p-4">
        <Skeleton className="h-24 w-full" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  return (
    <div>
      <ClaimTimeline claim={claim} />
    </div>
  );
}
